// ---- scroll reveals (content is visible without JS; this only adds motion) ----
const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
if(!reduced && 'IntersectionObserver' in window){
  const io = new IntersectionObserver(es=>{
    es.forEach(e=>{ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target);} });
  },{threshold:.1,rootMargin:'0px 0px -5% 0px'});
  document.querySelectorAll('.reveal:not(.in)').forEach(el=>io.observe(el));
}else{
  document.querySelectorAll('.reveal').forEach(el=>el.classList.add('in'));
}

// ---- gold dust rising (hero) ----
if(!reduced){
  const c = document.getElementById('dust');
  if(c){
    const x = c.getContext('2d');
    let W,H;
    function size(){
      W = c.width = c.offsetWidth * devicePixelRatio;
      H = c.height = c.offsetHeight * devicePixelRatio;
    }
    size(); addEventListener('resize',size);
    const N = Math.min(70, Math.floor(innerWidth/12));
    const ps = [];
    function spawn(anyY){
      return {
        x: Math.random(), y: anyY ? Math.random() : 1.05,
        r: .6 + Math.random()*1.5,
        v: .0004 + Math.random()*.0009,
        drift: (Math.random()-.5)*.0003,
        tw: Math.random()*Math.PI*2,
        ts: .008 + Math.random()*.02
      };
    }
    for(let i=0;i<N;i++) ps.push(spawn(true));
    (function tick(){
      x.clearRect(0,0,W,H);
      for(const p of ps){
        p.y -= p.v; p.x += p.drift; p.tw += p.ts;
        if(p.y < -.05) Object.assign(p, spawn(false));
        const a = .12 + Math.abs(Math.sin(p.tw))*.5;
        x.beginPath();
        x.arc(p.x*W, p.y*H, p.r*devicePixelRatio, 0, 7);
        x.fillStyle = `rgba(225,190,120,${a})`;
        x.fill();
      }
      requestAnimationFrame(tick);
    })();
  }
}

